module.exports = __webpack_public_path__ + "static/media/gift.f96246b2.gif";